import React from 'react';
import PropTypes from 'prop-types';

import { SuiSpinner } from '@splashthat/sui';
import FullScreenView from 'common/components/FullScreenView';

const FullScreen = ({ children, open, loading, onRequestClose }) => (
    <FullScreenView
        title=""
        hasTopBar={false}
        open={open}
        onRequestClose={onRequestClose}
        popoverClassName={'Modal__popover'}
    >
        {loading ? <SuiSpinner /> : children}
    </FullScreenView>
);

FullScreen.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    open: PropTypes.bool,
    loading: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
};

FullScreen.defaultProps = {
    open: false,
    loading: false,
};

export default FullScreen;
